/* Scroll Lock on Mobile */
var SCROLL_POSITION = 0;
var swatchesExpandedState = {};
function mobileBodyLock(lockType){
  if (window.innerWidth < 990) {
    const $body = document.querySelector('body');
    if(lockType == 'lock'){
      SCROLL_POSITION = window.pageYOffset;
      $body.style.overflow = 'hidden';
      //$body.style.position = 'fixed';
      $body.style.top = `-${SCROLL_POSITION}px`;
      $body.style.width = '100%';
    }else if(lockType == 'unlock'){
      $body.style.removeProperty('overflow');
      $body.style.removeProperty('position');
      $body.style.removeProperty('top');
      $body.style.removeProperty('width');
      window.scrollTo(0, SCROLL_POSITION);
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));

    // Allow multiple accordion tabs to stay open - removed auto-close behavior
    // if (summary.closest('.product__accordion')) {
    //   document.querySelectorAll('.product__accordion [id^="Details-"][open]').forEach((details) => {
    //     const currentSummary = details.querySelector('summary');

    //     if (summary !== currentSummary) {
    //       details.removeAttribute('open');
    //     }
    //   });
    // }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
                          if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

  if (mouseClick) return;

  currentFocusedElement = document.activeElement;
  currentFocusedElement.classList.add('focused');

}, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.querySelector('.quantity__input').addEventListener('change', function(e){
      if(e.target.value < e.target.min) {
        e.target.value = e.target.min;
      }
    })
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
                 detailsElement.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', true);
      !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
    }, 100);
  }
}

openMenuDrawer(summaryElement) {
  setTimeout(() => {
             this.mainDetailsToggle.classList.add('menu-opening');
});
summaryElement.setAttribute('aria-expanded', true);

trapFocus(this.mainDetailsToggle, summaryElement);
document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
}

closeMenuDrawer(event, elementToFocus = false) {
  this.mainDetailsToggle.classList.remove('menu-opening');
  this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
  });
  document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  removeTrapFocus(elementToFocus);
  this.closeAnimation(this.mainDetailsToggle);
}

onFocusOut(event) {
  setTimeout(() => {
             if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
});
}

onCloseButtonClick(event) {
  const detailsElement = event.currentTarget.closest('details');
  this.closeSubmenu(detailsElement, event);
}

closeSubmenu(detailsElement, event) {
  if (event.target.classList.contains('js-level-3')) {
    detailsElement.querySelectorAll('.teams-sub-links').forEach(element => element.style.removeProperty('transform'));
  } else {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    detailsElement.querySelectorAll('.teams-sub-links').forEach(element => element.style.removeProperty('transform'));

    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
}

closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
               this.mainDetailsToggle.classList.add('menu-opening');
  });

summaryElement.setAttribute('aria-expanded', true);

trapFocus(this.mainDetailsToggle, summaryElement);
document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
}

closeMenuDrawer(event, elementToFocus) {
  super.closeMenuDrawer(event, elementToFocus);
  this.header.classList.remove('menu-open');
}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (!this.classList.contains('media-modal')) {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (deferredElement && deferredElement.tagName === 'VIDEO') {
        deferredElement.muted = true;
        deferredElement.playsInline = true;
        var playWhenReady = function() { deferredElement.play().catch(function() {}); };
        if (deferredElement.readyState >= 2) playWhenReady();
        else {
          deferredElement.addEventListener('loadeddata', playWhenReady, { once: true });
          deferredElement.addEventListener('canplay', playWhenReady, { once: true });
          deferredElement.load();
        }
      }
      if (focus && deferredElement) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (this.closest('.product--media_slider')) {
      const mediaSlickIndex = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      $('.product__media--slick').slick('slickGoTo', mediaSlickIndex.dataset.slickIndex)
    } else {
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const class_name = `.price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.querySelector(class_name);
      const source = html.querySelector(class_name);

      if (source && destination) {
        const destinations = document.querySelectorAll(class_name);
        destinations[0].innerHTML = source.innerHTML;
        destinations[0].classList.remove('visibility-hidden');
        if (destinations[1]) {
          destinations[1].innerHTML = source.innerHTML;
          destinations[1].classList.remove('visibility-hidden');
        }
      }

      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

      const rewardsMsg = html.querySelector('.rewards-msg').innerHTML;

      document.querySelector('.rewards-msg').innerHTML = rewardsMsg;

      const notifyContainer = document.querySelector('.js-notify');

      notifyContainer.querySelector('input[name="variant"]').value = document.querySelector('.product-form input[name="id"]').value;

      if (this.currentVariant.available) {
        notifyContainer.classList.add('hidden');
        document.querySelector('.rewards-msg').classList.remove('hidden');
        document.querySelector('.product-form__submit').classList.remove('hidden');
      } else {
        notifyContainer.classList.remove('hidden');
        document.querySelector('.rewards-msg').classList.add('hidden');
        document.querySelector('.product-form__submit').classList.add('hidden');
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const limiterAddButton = productForm.querySelector('#add-to-cart-button');
    const limiterAddButtonText = productForm.querySelector('#add-to-cart-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if(limiterAddButton) limiterAddButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
        if(limiterAddButtonText) limiterAddButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if(limiterAddButton) limiterAddButton.removeAttribute('disabled');
      if(limiterAddButtonText) limiterAddButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    const colorSwatches = [...this.querySelectorAll('.js-color-change')];

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', this.handleSwatchChange.bind(this));
    });
  }

  handleSwatchChange(e) {
    e.preventDefault();
    if (e.target.classList.contains('is-active')) {
      return;
    }

    const url = e.target.getAttribute('href');
    if (!url) {
      return
    }

    fetch(
    `${url}`
    )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

      const sections = [
        '.product--media_slider'
      ];

      sections.forEach(section => {
        const responseSection = html.querySelector(section);
        const destination = document.querySelector(section);

        if (responseSection && destination) {
          destination.replaceWith(responseSection);
        }
      })

      let scripts = html.querySelectorAll('script');
      scripts.forEach(script => {
        let newScript = document.createElement('script');
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        document.body.appendChild(newScript);
      });

      history.replaceState({}, '', url);
    });
  };

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
if($(".bought_with_upper .card__heading").length){
  setTimeout(() => {
             jQuery(document).ready(function($) {
    equalHeight($(".bought_with_upper .card__heading"));
    equalHeight($(".bought_with_upper .caption-with-letter-spacing"));
  });
}, 3000);
}

/**
 * Close minicart
 * @param  {} e Event
 */
$('body').on("click", ".Drawer__Close", function (e) {
  e.preventDefault();
  $('body').removeClass('expanded');
  //unlock mobile body
  mobileBodyLock('unlock');
});

/**
 * Open minicart
 * @param  {} e Event
 */
$('body').on("click", "#cart-icon-bubble", function (e) {
  e.preventDefault();
  if (window.GWP_settings && window.GWP_settings.gwp_enabled && typeof window.GWP_cart_validation === 'function') {
    Promise.resolve(window.GWP_cart_validation()).then(function (result) {
      if (!result || !result.cartChanged) {
        refreshCart();
      }
    }).catch(function () {
      refreshCart();
    });
  } else {
    refreshCart();
  }
});

function removecartitem(key,isGiftItem) {
  // set the data to send
  let sendData = {
    id: key,
    quantity: 0
  }
  const cartItemElement = document.querySelector(`.CartItemWrapper[data-line-key="${key}"]`);
  const qtyInput = cartItemElement && cartItemElement.querySelector('.QuantitySelector__CurrentQuantity');
  const cartItemQuantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
  // gift item check
  if( isGiftItem) {
    sessionStorage.setItem('giftItem', true)
  }

  // datalayer info for the dispatched event
  const dataLayerInfo = {
    eventType: 'mini-cart-item-remove',
    itemQuantity: cartItemQuantity // send the original quantity
  }

  let cartBeforeRemoval = null;

  // First, fetch cart items before removing.
  $.ajax({
    url: `/cart.js`,
    dataType: "json",
    success: function success(res) {
      cartBeforeRemoval = res;

      // Then, proceed to change the cart.
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: sendData,
        async: false,
        cache: false,
        dataType: 'json',
        success: function (res) {
          // If removing a gift item, update active states
          if (isGiftItem) {
            const cartItemElement = document.querySelector(`.CartItemWrapper[data-line-key="${key}"]`);
            if (cartItemElement) {
              const variantId = cartItemElement.querySelector('.CartItem').getAttribute('data-variant-id');
              if (variantId) {
                updateGiftItemActiveState(variantId, false);
              }
            }
          }

          var dispatchRemoved = function () {
            document.dispatchEvent(new CustomEvent("cart:item:removed"));
            document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
              "response": cartBeforeRemoval,
              "event": dataLayerInfo,
              "items_changed": [{
                quantity_changed: cartItemQuantity,
                quantity: cartItemQuantity,
                id: key
              }]
            }}));
          };

          if (window.GWP_settings && window.GWP_settings.gwp_enabled && typeof window.GWP_cart_validation === 'function') {
            Promise.resolve(window.GWP_cart_validation()).then(function (result) {
              if (!result || !result.cartChanged) {
                refreshCart();
              }
              dispatchRemoved();
            }).catch(function () {
              refreshCart();
              dispatchRemoved();
            });
          } else {
            refreshCart();
            dispatchRemoved();
          }
        }
      });
    }
  });

  // add alert when item removed.
  $('#remove-from-cart-msg').html('Item removed from Bag!').fadeIn();
}


/* Update cart line item quantity */
function updatecartitem(quantity, key, trigger) {
  const newQty = quantity;
  const previousQty = trigger.dataset.previousQuantity;
  let quantityDifference = 0;
  let sendData = {
    updates: {}
  }
  sendData.updates[`${key}`] = newQty;

  //determine if item quantity increased or decreased
  let eventType = null;

  if(newQty > previousQty){
    eventType = 'mini-cart-item-quantity-add';
    quantityDifference = (newQty - previousQty);
  }else{
    eventType = 'mini-cart-item-quantity-remove';
    quantityDifference = (previousQty - newQty);
  }

  const dataLayerInfo = {
    eventType: eventType,
  }

  // Find the QuantitySelector parent and show loader immediately
  const quantitySelector = trigger.closest('.QuantitySelector');
  if (quantitySelector) {
    quantitySelector.classList.add('disabled');
  }

  // Update quantity optimistically (immediately show the new value)
  trigger.value = newQty;
  trigger.dataset.previousQuantity = newQty;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: sendData,
    async: true, // Changed to async for better performance
    cache: false,
    dataType: 'json',

    success: function (res) {
      // Remove loader after successful update
      if (quantitySelector) {
        quantitySelector.classList.remove('disabled');
      }

      var dispatchUpdated = function () {
        document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
          "response": res,
          "event": dataLayerInfo,
          "items_changed": [{
            quantity_changed: parseInt(newQty),
            quantity: parseInt(newQty),
            id: key
          }]
        }}));
      };

      // Run GWP threshold check before mini cart refresh so gifts are removed first
      if (window.GWP_settings && window.GWP_settings.gwp_enabled && typeof window.GWP_cart_validation === 'function') {
        Promise.resolve(window.GWP_cart_validation()).then(function (result) {
          if (!result || !result.cartChanged) {
            refreshCart();
          }
          dispatchUpdated();
        }).catch(function () {
          refreshCart();
          dispatchUpdated();
        });
      } else {
        refreshCart();
        dispatchUpdated();
      }
    },
    error: function(xhr, status, error) {
      // Remove loader on error
      if (quantitySelector) {
        quantitySelector.classList.remove('disabled');
      }
      // Revert quantity on error
      trigger.value = previousQty;
      trigger.dataset.previousQuantity = previousQty;
      
      // Show error message
      console.error('Cart update failed:', error);
      alert('Failed to update cart. Please try again.');
    },
    complete: function () {
      $('#ajax-loading-image').fadeOut(1000);
    }
  });
}

/* Click event to update line item qty */
$("#sidebar-cart").on('click', '.QuantitySelector__Button', function (e) {
  e.preventDefault();
  
  // Prevent multiple clicks while processing
  const $button = $(this);
  const quantitySelector = $button.closest('.QuantitySelector');
  if (quantitySelector.hasClass('disabled')) {
    return; // Already processing, ignore click
  }
  
  let key = $button.data('line-key');
  let input = $button.siblings('.QuantitySelector__CurrentQuantity');
  let minimum_quantity = parseInt(input.attr('min'));
  let new_quantity = parseInt($button.data('quantity'));

  // Check if this is a minus button and quantity would be 0
  if ($button.hasClass('minus') && new_quantity < minimum_quantity) {
    // Remove the item instead of setting quantity to 0
    const cartItemElement = document.querySelector(`.CartItemWrapper[data-line-key="${key}"]`);
    const isGiftItem = cartItemElement && (cartItemElement.dataset.gift === 'true' || cartItemElement.querySelector('.CartItem--gwp, .CartItem[data-gwp-item="true"]'));
    removecartitem(key, isGiftItem);
    return;
  }

  if(new_quantity < minimum_quantity) {
    return;
  }

  updatecartitem(new_quantity, key, input[0]);
});

// Return line item quantity from rebuy smart cart DOM
function returnQuantityFromRebuySmartCart(element) {
  const cloneQuantityWrapper = element.cloneNode(true);
  cloneQuantityWrapper.querySelector('span').remove();
  return cloneQuantityWrapper.innerText.trim()
}

// Add event listner to catch Rebuy cart button actions
document.addEventListener('click', (event) => {
  const element = event.target;
  if($(element).parents('.rebuy-cart__flyout-item').length == 0) return;

  if(($(element).is('button')) || ($(element).parents('button').length > 0)){

    const button = ($(element).is('button')) ? $(element)[0] : $(element).parents('button')[0]

    let bundleId = Array.from(button.closest('.rebuy-cart__flyout-item').classList).filter(function(value){
      if(value.indexOf('property-_bundle_key:') >= 0) {
        return value;
      }
    });

    bundleId = bundleId[0].replace('property-_bundle_key:', '');

    if(bundleId) {
      if(button.classList.contains('rebuy-cart__flyout-item-remove')) {
        sessionStorage.setItem('cartAction', 'update-'+bundleId+'-0')
      }
      else if(button.getAttribute('alt').toLowerCase().indexOf('increase') >= 0) {
        const quantity = Number(returnQuantityFromRebuySmartCart(button.previousElementSibling)) + 1;
        sessionStorage.setItem('cartAction', 'update-'+bundleId+'-'+quantity)
      }
      else if(button.getAttribute('alt').toLowerCase().indexOf('decrease') >= 0) {
        const quantity = Number(returnQuantityFromRebuySmartCart(button.nextElementSibling)) - 1;
        sessionStorage.setItem('cartAction', 'update-'+bundleId+'-'+quantity);
      }
    }
  }
});

// Add rebuy cart event listener to update bundles
document.addEventListener('rebuy:cart.change', (event) => {
  if(!sessionStorage.getItem('cartAction')) return;

  const cartItems = event.detail.cart.cart.items;
  const [action, bundleId, qty] = sessionStorage.getItem('cartAction').split('-');
  let itemsToUpdate = {updates:{}};

  // update bundle items
  cartItems.forEach((value, index) => {
    const itemBundleId = value.properties._bundle_key;

    if(itemBundleId === bundleId) {
      itemsToUpdate['updates'][value.key] = Number(qty)
    }
  });

  if(Object.keys(itemsToUpdate.updates).length > 0) {
    $('ul[data-smartcart-items]').find('button').prop('disabled',true)
    fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemsToUpdate)
    })
    .then(response => {
      sessionStorage.removeItem('cartAction')
      $('ul[data-smartcart-items]').find('button').prop('disabled',false)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});

/**************************/
/* Gifting in Cart Drawer */
/*************************/

/* Click event to open gifting in minicart */
$('body').on('click', '.edit_btn', function() {
  $(".Drawer__total_price").css('display','none');
  $('.giftcard_dtl').animate({height: 'toggle'});
  $('.edit_btn').hide();
  $('.cross_header').slideToggle(); toggleGiftBorder();
});

/* Click event to toggle gifting in minicart */
$('body').on("change", ".cross_header", function(){
  $('.giftcard_dtl').animate({height: 'toggle'});
  $(".Drawer__total_price").css('display','flex');
});

/* Click event of note checkbox */
$('body').on('click', '.cart-gift-note-product', function(event) {
  const checkboxes = document.getElementsByClassName('cart-gift-note-product')
  checkboxes.forEach((item) => {
    if (item == event.target){
      $('.wrape_Price_option').text(item.dataset.productPrice);
    }
    if (item !== event.target) item.checked = false
  });
  //gift note was de-selected
  if(event.target.checked == false){
    $('.wrape_Price_option').text('');
  }
});


/* Add gift wrap product to cart */
$('body').on('change', '#giftpack', function(e) {
  const $form = $(this).parents('form');
  const gift_wrap_id = $form.find('.note_grift').attr('data-product');
  if(!!gift_wrap_id == false) return;

  const is_checked = $form.find('.note_grift').is(':checked');
  if(is_checked){ //add gift wrapping and attributes
    //$("#is_gft").addClass('saveable');

    let formData = {
      'items': [{
       'id': gift_wrap_id,
       'quantity': 1,
       }],
       'attributes': {
        'Is This a Gift?': $form.find('.isgift:checked').val(),
        'Gift Wrap': $form.find('.note_grift:checked').val()
      }
     };
     fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
        refreshCart();
     })
     .catch((error) => {
       console.error('Error:', error);
     });
  }
  else //remove gift wrapping and attributes
  {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    }).then(cart => {
      //check if cart has gift note items, and if so, do NOT remove 'Is This a Gift' attribute
      let attrs = {
        'Gift Wrap': ""
      }
      let cartHasNote = false;
      for (const item of cart.items) {
        if(!!item.properties && item.title.includes('Gift Note')){ //TODO: refactor for line item props
          cartHasNote = true;
          break;
        }
      }
      if(!cartHasNote){
        attrs['Is This a Gift?'] = "";
      }
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: {
          attributes: attrs,
          updates: {
            [gift_wrap_id]: 0
          }
        },
        success: function(){
          refreshCart();
        }
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});


/*
 Save gifting information to cart data
*/
function saveGiftingData(){
  //get product data
  let $form = $('form#minicart-form');
  let products = {};
  $('.checkbox_section input').each(function() {
    if(!!$(this).attr('data-product') == false) return;
    products[$(this).attr('data-product')] = $(this).is(':checked') ? 1 : 0;
  });

  //send request
  let note = "";
  if($form.find('.input_to').val()){
    note += `To: ${$form.find('.input_to').val()}`;
  }
  if($form.find('.input_from').val()){
    if(note != "") note += ` \n`;
    note += `From: ${$form.find('.input_from').val()}`;
  }
  if($form.find('.textarea_txt').val()){
    if(note != "") note += ` \n`;
    note += `Message: ${$form.find('.textarea_txt').val()}`;
  }
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    dataType: "json",
    data: {
      attributes: {
        'Is This a Gift?': $form.find('.isgift:checked').val(),
        'Note Option': (typeof $form.find('.noteattr:checked').val() !== 'undefined') ? $form.find('.noteattr:checked').val() : "",
        'To': $form.find('.input_to').val(),
        'From': $form.find('.input_from').val(),
        'Gift Message': $form.find('.textarea_txt').val(),
      },
      note: note,
      updates: products
    },
    success: function(d){
      refreshCart();
    }
  });
}

$('body').on('click', '.Cart__Checkout', function(e) {
  saveGiftingData();
})

/* Click event to save gift information in minicart */
$('body').on('click', '.save_btn', function(e) {
  e.preventDefault();

  //animate dom
  $('.giftcard_dtl').animate({height: 'toggle'});
  $('.cross_header').slideToggle();  toggleGiftBorder();
  $(".Drawer__total_price").css('display','flex');
  $('#is_gft').addClass("saveable");
  $('.main_gift_card').find('.edit_btn').show();

  //save
  saveGiftingData();

});

/*
 On blur of gifting to/from/message fields, auto-save the information entered
*/
$('body').on('blur', '.gift-msg-field', function(e) {
  e.preventDefault();
  saveGiftingData();
});

/*
 On blur of gifting to/from/message fields, auto-save the information entered
*/
$('body').on('change', '.cart-gift-note-product', function(e) {
  e.preventDefault();
  saveGiftingData();
});



/*
 Remove all gift notes, gift wrapping, gift cart attributes, and gift cart notes
*/
function removeAllGiftingFromCart(){

  //uncheck all inouts, remove all gift field text
  const checkboxes = document.getElementsByClassName('cart-gift-note-product')
  checkboxes.forEach((item) => {
    item.checked = false;
  });
  $('.gift-msg-field').val(null);
  document.querySelector("#giftpack").checked = false;

  //modify cart data
  let products  = {};
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json();
  }).then(cart => {
    for (const item of cart.items) {
      if(!!item.properties && item.title.includes('Gift')){  //TODO: refactor for line item props
        products[item.key] = 0;
      }
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          attributes: {
            'Is This a Gift?': "",
            'Note Option': "",
            'To': "",
            'From': "",
            'Gift Message': "",
            'Gift Wrap': ""
          },
          note: "",
          updates: products
        }
      )
    })
    .then(response => {
      refreshCart();
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

/* Mini Giftbox Checkbox change event */
$('body').on("change", ".isgift", function(){
  //gifting already saved by user
  if($("#is_gft").hasClass("saveable")){
    $(this).removeClass("saveable");
    $(this).prop("checked",false);
    $('.main_gift_card').find('.edit_btn').hide();
    //if widget is open close. Else remove edit btn
    if($('.giftcard_dtl').height() > 0){
      closeGiftWidget();
    }else{
      $('.main_gift_card').find('.edit_btn').hide();
    }
    //remove all gifting
    removeAllGiftingFromCart();
  }
  //gifting not yet set by user
  else{
    //user clicked checkbox to open gifting
    if($(this).is(':checked')){
      $(this).parent().siblings('.giftcard_dtl').animate({height: 'toggle'});
      $(".Drawer__total_price").css('display','none');
      $('.cross_header').slideToggle();  toggleGiftBorder();
    }
    //user clicked checkbox to close gifting
    else{
      $('.cross_header').slideToggle();  toggleGiftBorder();
      $(this).parent().siblings('.giftcard_dtl').animate({height: 'toggle'});
      $(".cart_heading").css('display','block');
      $(".Drawer__Cart_count").css('display','block');
      $(".Drawer__total_price").css('display','flex');
      //remove all gifting
      removeAllGiftingFromCart();
    }
    $('.main_gift_card').find('.edit_btn').hide();
  }
});

/* Gifting X icon click */
$('body').on('click', '.cross_header svg', function() {
  closeGiftWidget();

  //uncheck gift enabler if not saved
  const $giftCheckbox = $("#is_gft");
  if($giftCheckbox.hasClass("saveable") == false){
    $giftCheckbox.removeClass("saveable");
    $giftCheckbox.prop("checked",false);
  }
  else if($giftCheckbox.hasClass("saveable")) {
    $('.main_gift_card').find('.edit_btn').show();
  }
});

/* Show remaining chars in text message field */
$('body').on('keyup', "#length_count",function () {
  $(this).next().find('#current-count').text($(this).val().length);
});

/*  Show border when gifting widget is visible */
function toggleGiftBorder(){
  const class_name = 'sticky_footer--gift';
  const $footer = $(".sticky_footer.Drawer__Container");
  $footer.toggleClass(class_name);
}

/* Toggle open/close of gift widget */
function closeGiftWidget(){
  $('.cross_header').slideToggle();
  toggleGiftBorder();
  $('.main_gift_card').find('.giftcard_dtl').animate({height: 'toggle'});
  $(".cart_heading").css('display','block');
  $(".Drawer__Cart_count").css('display','block');
  $(".Drawer__total_price").css('display','flex');
}

/* Toggle gift message fields */
function toggleGiftMessageFields(show){
  if(show){
    $('.gift-msg-field').attr('disabled',false);
  }else{
    $('.gift-msg-field').attr('disabled',true);
    $('.gift-msg-field').val('');
  }
}

/**********************/
/* Refresh Cart Drawer */
/**********************/
function refreshCart(){

  $(".gift-item").removeClass("clicked");

  $.ajax({
    url: '/cart?view=drawer',
    type: 'get'
  }).done(function (cartHTML) {
    const $minicart = $('#sidebar-cart');
    const $ajaxCart = $(cartHTML);
    let cartItemCount = $ajaxCart.find('#minicart-count').attr('data-cartcount');

    // Gifting Section
    let gwpVariantId = '';
    $.ajax({
      url: '/cart.js',
      type: 'get',
      dataType: 'json',
      success: function(cart) {
        let giftInCart = false;
        let cartPriceWithoutGift = 0;
        let cartTotalPrice = 0;
        let cartItemsWithoutGift = 0;
        cart.items.forEach(item => {
          const p = item.properties || {};
          const isGift = p['_GWP_item'] || p['_is_GWP'];
          if (isGift) {
            giftInCart = true;
            if (!gwpVariantId) gwpVariantId = item.variant_id;
            if (p['_GWP_item']) {
              const raw = p['_GWP_item_discount'];
              const pct =
                raw === null || raw === undefined || String(raw).trim() === ''
                  ? 100
                  : parseInt(raw, 10);
              const frac = (Number.isNaN(pct) ? 100 : pct) / 100;
              cartTotalPrice += (item.original_line_price * (1 - frac)) / 100;
            }
          } else {
            cartTotalPrice += item.final_line_price / 100;
            cartPriceWithoutGift += item.final_line_price / 100;
            cartItemsWithoutGift += item.quantity;
          }
        });

        //update header item count
        if (giftInCart) {
          $(".gift_content").addClass("active");
        } else {
          $(".gift_content").removeClass("active");
        }

        const _priceHtml = `$${cartTotalPrice.toFixed(2)}`;
        $minicart.find('.Drawer__total_price .cart_subtotal').html(_priceHtml);

        let giftItemWrapper = document.querySelectorAll('.gift-item');
        giftItemWrapper.forEach(item => {
          const giftVariantId = item.getAttribute('data-variant');
          const thresholdRaw = item.getAttribute('data-threshold');
          const thresholdNum = thresholdRaw != null && String(thresholdRaw).trim() !== '' ? parseFloat(String(thresholdRaw), 10) : NaN;

          item.classList.remove("active", "loading", "clicked");

          if (!Number.isNaN(thresholdNum) && thresholdNum <= cartPriceWithoutGift) {
            item.classList.add("available");
          } else {
            item.classList.remove("available");
          }

          let isInCart = false;
          cart.items.forEach(cartItem => {
            const cp = cartItem.properties || {};
            if ((cp['_GWP_item'] || cp['_is_GWP']) && cartItem.variant_id == giftVariantId) {
              isInCart = true;
            }
          });

          if (isInCart) {
            item.classList.add("active");
          }
        });
        // Do not remove GWP lines here — assets/gwp.js (GWP_cart_validation) already enforces threshold
        // and collection rules. This block used to POST quantity=0 and caused gifts to disappear when
        // .gift-item widgets / thresholds did not match cart state (race or config drift).
      }
    });

    //update header item count
    $('.cart-count-bubble > span').text(cartItemCount);

    //update minicart header [div.Drawer__Header]
    const headerHtml = $ajaxCart.find('.Drawer__Header').html();

    //update progress bar [div.Drawer_progress]
    const progressHtml = $ajaxCart.find('.Drawer_progress').html();

    //update progress bar [div.Drawer_progress]
    const tieredProgressHtml = $ajaxCart.find('.gwp-tiered-bar-wrapper').html();

    //update minicart items [div.Cart__ItemList]
    const itemsHtml = $ajaxCart.find('.Cart__ItemList').html();

    //update subtotal bar [div.Drawer__total_price]
    const priceHtml = $ajaxCart.find('.Drawer__total_price').html();

    $minicart.find('.Drawer__Header').html(headerHtml);
    $minicart.find('.Drawer_progress').html(progressHtml);
    $minicart.find('.gwp-tiered-bar-wrapper').html(tieredProgressHtml);
    $minicart.find('.Cart__ItemList').html(itemsHtml);
    $minicart.find('.Drawer__total_price').html(priceHtml);

    //determine if cart is empty, then show and hide content
    if(cartItemCount == 0){
      $minicart.find('.Cart__Empty.Heading').show(); //show empty cart msg
      $minicart.find('.Drawer__Items').hide(); //hide items
      $minicart.find('.Drawer__Title').hide(); //hide top cart text
      $minicart.find('.hide-when-empty-cart').hide(); //hide footer elements
      $minicart.find('.show-when-empty-cart').show(); //show footer empty cart link
      $minicart.find('.Drawer__Main').removeClass('Drawer__Main--has-items'); // Remove the class when cart is empty
    } else {
      $minicart.find('.Cart__Empty.Heading').hide(); //hide empty cart msg
      $minicart.find('.Drawer__Items').show(); //show items
      $minicart.find('.Drawer__Title').show(); //show top cart text
      $minicart.find('.hide-when-empty-cart').show(); //show footer elements
      $minicart.find('.show-when-empty-cart').hide(); //hide footer empty cart link
      $minicart.find('.Drawer__Main').addClass('Drawer__Main--has-items'); // Add the class when cart has items
    }

    //open cart
    $('body').addClass('expanded');

    //lock mobile body
    mobileBodyLock('lock');

    
    // Rebuy widgets can be injected in the mini cart; re-init after refresh so
    // recommendations load/update when the drawer opens or cart changes.
    try {
      if (window.Rebuy && typeof window.Rebuy.init === 'function') {
        window.Rebuy.init();
      } else if (typeof Rebuy !== 'undefined' && typeof Rebuy.init === 'function') {
        Rebuy.init();
      }
    } catch (e) {
      // ignore
    }
  })
}

/**************************************/
/* CART ACTION - Bundle QTY CHANGE
/*******************************************/
//Bundle cart quantity input on change event
$(document).on('change', '[data-cart-quantity-input-bundle]', function(e) {
  console.log("Bundle quantity value change!");
  //disable inputs
  $(this).parents('.QuantitySelector').addClass('disabled');

  let data = { updates: {} };
  let $input = $(this);
  let newQty = parseInt($input.val());
  let previousQty = parseInt($input[0].dataset.previousQuantity);
  let items_changed = [];
  let eventType = null;
  let quantityDifference = 0;
  if(newQty === 0 ){
    eventType = 'mini-cart-item-remove';
    quantityDifference = previousQty;
  }
  else if(newQty > previousQty){
    eventType = 'mini-cart-item-quantity-add';
    quantityDifference = (newQty - previousQty);
  }else{
    eventType = 'mini-cart-item-quantity-remove';
    quantityDifference = (previousQty - newQty);
  }

  const dataLayerInfo = {
    eventType: eventType
  }
  let cartType = $input.attr('data-cart-quantity-input-bundle');
  //determine if minicart or cart page
  if(cartType == 'mini-cart'){
    $input.parents('[data-bundle-parent]').find('.CartItemWrapper--bundle__items').find('[data-bundle-item]').each(function(index){
      data.updates[$(this).data('item-key')] = newQty;
      items_changed.push({
        quantity_changed: quantityDifference,
        quantity: newQty,
        id: $(this).data('item-key')
      });
    });
  }

  if(eventType === "mini-cart-item-remove"){
    let cartBeforeRemoval = null;
    $.ajax({
      url: `/cart.js`,
      dataType: "json",
      async: true, // Changed to async for better performance
      success: function success(res) {
        cartBeforeRemoval = res;

        // Then, proceed to change the cart.
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          async: true, // Changed to async for better performance
          dataType: 'json',
          success: function (secondRes) {
            // Remove loader after successful update
            $input.parents('.QuantitySelector').removeClass('disabled');
            
            refreshCart();
            document.dispatchEvent(new CustomEvent("cart:item:removed"));
            document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
              "response": cartBeforeRemoval,
              "event": dataLayerInfo,
              "items_changed": items_changed
            }}));
          },
          error: function(xhr, status, error) {
            // Remove loader on error
            $input.parents('.QuantitySelector').removeClass('disabled');
            // Revert quantity on error
            $input.val(previousQty);
            $input[0].dataset.previousQuantity = previousQty;
            
            console.error('Bundle cart remove failed:', error);
            alert('Failed to remove item from cart. Please try again.');
          }
        });
      },
      error: function(xhr, status, error) {
        // Remove loader on error
        $input.parents('.QuantitySelector').removeClass('disabled');
        console.error('Failed to get cart:', error);
      }
    });
  } else {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      async: true, // Changed to async for better performance
      dataType: 'json',
      success: function (data) {
        // Remove loader after successful update
        $input.parents('.QuantitySelector').removeClass('disabled');
        
        if(cartType == 'mini-cart'){
          refreshCart();
        }
        document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
          "response": data,
          "event": dataLayerInfo,
          "items_changed": items_changed
        }}));
      },
      error: function(xhr, status, error) {
        // Remove loader on error
        $input.parents('.QuantitySelector').removeClass('disabled');
        // Revert quantity on error
        $input.val(previousQty);
        $input[0].dataset.previousQuantity = previousQty;
        
        console.error('Bundle cart update failed:', error);
        alert('Failed to update cart. Please try again.');
      }
    });
  }

});

/* Bundle Qty change triggered by +/- icons */
$(document).on('click', '.QuantitySelector__Button--bundle', function (e) {
  e.preventDefault();
  
  // Prevent multiple clicks while processing
  const $button = $(this);
  const quantitySelector = $button.closest('.QuantitySelector');
  if (quantitySelector.hasClass('disabled')) {
    return; // Already processing, ignore click
  }
  
  let qty_input = $button.siblings('input');
  let qty = parseInt(qty_input.val());
  qty_input.attr('data-previous-value', qty);
  if($button.hasClass('plus')){
    qty++;
  }else if($button.hasClass('minus')){
    qty--;
  }
  qty_input.val(qty).trigger('change');
});

/* Bundle Qty Remove */
$(document).on('click', '.CartItem__Remove--bundle', function (e) {
  e.preventDefault();
  $(this).parents('[data-bundle-parent]').find('[data-cart-quantity-input-bundle]').val(0).trigger('change');
});


/* Minicart Upsell Add Click Event */
$("body").on("click", ".Drawer_slider .card__link",function(e){
  e.preventDefault();
  const slide = $(this).parents('.single-frequent');
  const variantID = slide.find('.fplus').data("fproduct");
  const variantSKU = slide.find('.fplus').data("sku");
  slide.find('.fplus').trigger('click'); //custom datalayer function runs
  const items_added = [{
    quantity: 1,
    id: variantID,
    properties: {
      "upsell_item": "true",
      "upsell_item_source": "minicart",
      "upsell_item_SKU": variantSKU,
      "upsell_item_variant_id": variantID
    }
  }];
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { items: items_added },
    dataType: 'json',
    success: function (res) {
      slide.hide();
      document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
        {
          "response": res,
          "items_added": items_added,
          "rumpl_gwp_handled": true,
          "event": {
            "eventType": "mini_cart_upsell"
          }
        }
      }));
      if (typeof window.rumplAfterCartAddThenRefresh === 'function') {
        window.rumplAfterCartAddThenRefresh();
      } else {
        refreshCart();
      }
    }
  });
});

function replaceGift(gwpLinePosition, variantId, gwpThreshold, gwpDiscount, gwpSKU) {
  // Check if this gift item already exists in cart
  let existingGiftItem = null;
  let existingQuantity = 0;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find existing gift item with same variant
      for (const item of cart.items) {
        if (item.properties && item.properties['_GWP_item'] && item.variant_id == variantId) {
          existingGiftItem = item;
          existingQuantity = item.quantity;
          break;
        }
      }

      if (existingGiftItem) {
        // Update quantity of existing gift item
        const newQuantity = existingQuantity + 1;
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            id: existingGiftItem.key,
            quantity: newQuantity
          },
          success: function (res) {
            // Update active state for gift items
            updateGiftItemActiveState(variantId, true);
            refreshCart();
            document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
              {
                "response": res,
                "items_added": [{
                  quantity: 1,
                  id: variantId,
                  properties: {
                    "_GWP_item": "true",
                    "_GWP_item_threshold": gwpThreshold,
                    "_GWP_item_discount": gwpDiscount,
                    "_GWP_item_SKU": gwpSKU,
                    "_GWP_item_variant_id": variantId
                  }
                }],
                "event": {
                  "eventType": "mini_cart_upsell"
                }
              }
            }));
          }
        });
      } else {
        // Add new gift item
        const items_added = [{
          quantity: 1,
          id: variantId,
          properties: {
            "_GWP_item": "true",
            "_GWP_item_threshold": gwpThreshold,
            "_GWP_item_discount": gwpDiscount,
            "_GWP_item_SKU": gwpSKU,
            "_GWP_item_variant_id": variantId
          }
        }];

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { items: items_added },
          dataType: 'json',
          success: function (res) {
            // Update active state for gift items
            updateGiftItemActiveState(variantId, true);
            refreshCart();
            document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
              {
                "response": res,
                "items_added": items_added,
                "event": {
                  "eventType": "mini_cart_upsell"
                }
              }
            }));
          }
        });
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Function to update gift item active state
function updateGiftItemActiveState(variantId, isActive) {
  const giftItems = document.querySelectorAll('.gift-item');
  giftItems.forEach(item => {
    if (item.getAttribute('data-variant') == variantId) {
      if (isActive) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    }
  });
}

// Function to sync gift item states with cart
function syncGiftItemStates() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Reset all gift items to not active
      const giftItems = document.querySelectorAll('.gift-item');
      giftItems.forEach(item => {
        item.classList.remove('active');
      });

      // Set active state for items in cart
      cart.items.forEach(item => {
        if (item.properties && item.properties['_GWP_item']) {
          updateGiftItemActiveState(item.variant_id, true);
        }
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

/* Minicart Gift Add Click Event */
$("body").on("click", ".Drawer_gift .gift-item.available", function(e){
  e.preventDefault();
  const giftItem = $(this);

  $(".Drawer_gift .gift-item").removeClass("clicked");

  const variantsCount = parseInt(giftItem.data("count"));
  if (variantsCount == 1) {
    if (giftItem.hasClass("loading")) {
      return;
    }

    giftItem.addClass("loading");
    const variantId = giftItem.data("variant");
    const gwpThreshold = giftItem.data("threshold");
    const gwpDiscount = giftItem.data("discount");
    const gwpSKU = $(giftItem).data("sku");

    replaceGift(-1, variantId, gwpThreshold, gwpDiscount, gwpSKU);

    // Remove loading state after a short delay
    setTimeout(() => {
      giftItem.removeClass("loading");
    }, 1000);
  } else {
    giftItem.addClass("clicked");
  }

});

$("body").on("click", ".Drawer_gift .gift-item.clicked .card-gift-variants-options li", function(e){
  e.preventDefault();
  e.stopPropagation();
  if ($(this).hasClass("active") || $(this).hasClass("disabled")) {
    return;
  }

  const variantId = $(this).data("variant");
  const variantSKU = $(this).data("sku");
  const giftItem = $(this).closest(".gift-item");
  const optionsList  = $(this).closest(".card-gift-variants-options");

  optionsList.find("li").removeClass("active");
  $(this).addClass("active");
  giftItem.attr("data-variant", variantId);
  giftItem.attr("data-sku", variantSKU);

  const gwpThreshold = giftItem.data("threshold");
  const gwpDiscount = giftItem.data("discount");
  replaceGift(-1, variantId, gwpThreshold, gwpDiscount, variantSKU);

  // Remove clicked state after a short delay
  setTimeout(() => {
    giftItem.removeClass("clicked");
  }, 1000);
});

/* PDP Upsell Add Click Event */
$("body").on("click", ".usually_add",function(e){
  e.preventDefault();
  const variantID = $(this).data("variant-id");
  const variantSKU = $(this).data("variant-sku");
  const items_added = [{
    quantity: 1,
    id: variantID,
    properties: {
      "upsell_item": "true",
      "upsell_item_source": "pdp",
      "upsell_item_SKU": variantSKU,
      "upsell_item_variant_id": variantID
    }
  }]
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items: items_added },
    success: function (res) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
        {
          "response": res,
          "items_added": items_added,
          "rumpl_gwp_handled": true,
          "event": {
            "eventType": "pdp_upsell"
          }
        }
      }));
      if (typeof window.rumplAfterCartAddThenRefresh === 'function') {
        window.rumplAfterCartAddThenRefresh();
      } else {
        refreshCart();
      }
    }
  });
});

/* Add Custom DataLayer Event for PDP/MiniCart Upsells */
function addCustomEventProductRec(data){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}


let imageContainers = document.querySelectorAll('.image-content');
imageContainers.forEach(img => {
  let imageBtns = img.querySelectorAll('.image-content__actions .image-content__btn');
    $(img).click(function() {
      if ( imageBtns.length < 2) {
        window.location = $(this).find(".image-content-link-wrapper").attr("href");
        return false;
        }
    });
});




class SlickSliderComponent extends HTMLElement {
  constructor() {
    super();

    this.main = this.querySelector('ul.product__media-list');
    this.thumbnails = this.querySelector('ul.product__media-thumbnails');
    this.lastKnownMobileState = window.innerWidth <= 768;
    this.initSlider();
    this.initThumbnailNavigation();
  }

  loadHiddenSliderImages() {
    let imgSelector = 'img.product-slider-image.mobile-image.tw-hidden';

    if (window.innerWidth > 550) {
      imgSelector = 'img.product-slider-image.desktop-image.tw-hidden';
    }
    let imgs = this.querySelectorAll(imgSelector);
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].classList.remove("tw-hidden");
    }
  }

  createCustomDots(slick) {
    const dotsContainer = slick.$dots;
    const totalSlides = slick.$slides.length;
    dotsContainer.empty();
    for (let i = 0; i < Math.min(5, totalSlides); i++) {
      dotsContainer.append('<li><button type="button">' + (i + 1) + '</button></li>');
    }

    dotsContainer.on('click', 'button', function() {
      const goToSlide = $(this).text() - 1;
      slick.slickGoTo(goToSlide);
    });
  }

  updateCustomDots(slick, currentSlide) {
    const dotsContainer = slick.$dots;
    const totalSlides = slick.$slides.length;
    const currentDotIndex = currentSlide % 5;
    dotsContainer.children().removeClass('slick-active');
    dotsContainer.children().eq(currentDotIndex).addClass('slick-active');

    // Update the text of the dots
    dotsContainer.children().each(function(index) {
      const dotNumber = (currentSlide - currentDotIndex + index + totalSlides) % totalSlides;
      $(this).children('button').text(dotNumber + 1);
    });
  }

  initSlider() {
    const that = this;

    $(this.main).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      that.loadHiddenSliderImages();
    });

    $(this.main).on('init', function(event, slick) {
      if (slick.$slides.length > 5 && window.innerWidth <= 767) {
        that.createCustomDots(slick);
        that.updateCustomDots(slick, 0);
      }
    });

    $(this.main).on('afterChange', function(event, slick, currentSlide) {
      if (slick.$slides.length > 5 && window.innerWidth <= 767) {
        that.updateCustomDots(slick, currentSlide);
      }
    });

    // Initialize main slider first
    this.initMainSlider();
    
    // Initialize thumbnail slider after main slider is ready
    setTimeout(() => {
      this.initThumbnailSlider();
      this.showThumbnailsOnMobile();
    }, 50);
  }

  initMainSlider() {
    $(this.main).slick({
      autoplay: false,
      infinite: false,
      slidesPerRow: 1,
      slidesToShow: 1,
      focusOnSelect: true,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: `<button type="button" class="slick-next">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
          <path d="M0 8l.866.848L8.258 16 10 14.305 3.484 8 10 1.7 8.258 0 .866 7.153z"/>
        </svg>
      </button>`,
      prevArrow: `<button type="button" class="slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
          <path d="M0 8l.866.848L8.258 16 10 14.305 3.484 8 10 1.7 8.258 0 .866 7.153z"/>
        </svg>
      </button>`,
      dots: true,
      fade: true,
      asNavFor: 'ul.product__media-thumbnails',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
            arrows: true
          }
        }
      ]
    });
  }

  initThumbnailSlider() {
    const isMobile = window.innerWidth <= 768;
    
    $(this.thumbnails).slick({
      autoplay: false,
      vertical: !isMobile,
      infinite: false,
      verticalSwiping: !isMobile,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      touchThreshold: 8,
      arrows: false,
      dots: false,
      asNavFor: 'ul.product__media-list',
      focusOnSelect: true,
      centerMode: false,
      centerPadding: isMobile ? '20px' : '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            verticalSwiping: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            touchThreshold: 8,
            centerMode: false,
            centerPadding: '20px'
          }
        }
      ]
    });

    // Ensure synchronization after initialization
    $(this.thumbnails).on('init', () => {
      setTimeout(() => {
        this.syncSliders();
      }, 100);
    });
  }

  syncSliders() {
    // Ensure both sliders are synchronized
    if (this.main && this.main.slick && this.thumbnails && this.thumbnails.slick) {
      const currentSlide = this.main.slick.currentSlide;
      this.thumbnails.slick.slickGoTo(currentSlide);
    }
  }

  showThumbnailsOnMobile() {
    if (!this.thumbnails) return;
    
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Force show thumbnails on mobile
      this.thumbnails.style.display = 'block';
      this.thumbnails.style.visibility = 'visible';
      
      // Also show the container
      const container = this.thumbnails.closest('.thumbnail-nav-container-CTM');
      if (container) {
        container.style.display = 'flex';
        container.style.visibility = 'visible';
      }
    } else {
      // Ensure thumbnails are visible on desktop
      this.thumbnails.style.display = 'block';
      this.thumbnails.style.visibility = 'visible';
      
      // Also ensure the container is visible
      const container = this.thumbnails.closest('.thumbnail-nav-container-CTM');
      if (container) {
        container.style.display = 'flex';
        container.style.visibility = 'visible';
      }
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    const wasMobile = this.lastKnownMobileState;
    
    // Only recreate sliders if mobile state has changed
    if (wasMobile !== undefined && wasMobile !== isMobile) {
      // Destroy existing sliders
      if (this.main && this.main.slick) {
        this.main.slick('destroy');
      }
      if (this.thumbnails && this.thumbnails.slick) {
        this.thumbnails.slick('destroy');
      }
      
      // Reinitialize sliders with new settings
      setTimeout(() => {
        this.initMainSlider();
        setTimeout(() => {
          this.initThumbnailSlider();
          this.showThumbnailsOnMobile();
          this.syncSliders();
        }, 50);
      }, 100);
    }
    
    // Update mobile state
    this.lastKnownMobileState = isMobile;
    
    // Always show/hide thumbnails based on screen size
    this.showThumbnailsOnMobile();
  }

  initThumbnailNavigation() {
    const prevBtn = this.querySelector('.thumbnail-nav-btn--prev');
    const nextBtn = this.querySelector('.thumbnail-nav-btn--next');
    
    if (!prevBtn || !nextBtn || !this.thumbnails) return;

    // Update button states based on current position
    const updateButtonStates = () => {
      if (!this.thumbnails.slick) return;
      
      const currentSlide = this.thumbnails.slick.currentSlide;
      const totalSlides = this.thumbnails.slick.slideCount;
      const slidesToShow = this.thumbnails.slick.options.slidesToShow;
      const isVertical = this.thumbnails.slick.options.vertical;
      
      // For mobile (horizontal), use different logic
      if (!isVertical) {
        // Enable/disable prev button for horizontal layout
        if (currentSlide <= 0) {
          prevBtn.disabled = true;
        } else {
          prevBtn.disabled = false;
        }
        
        // Enable/disable next button for horizontal layout
        if (currentSlide >= totalSlides - slidesToShow) {
          nextBtn.disabled = true;
        } else {
          nextBtn.disabled = false;
        }
      } else {
        // Desktop vertical layout logic (existing)
        if (currentSlide <= 0) {
          prevBtn.disabled = true;
        } else {
          prevBtn.disabled = false;
        }
        
        if (currentSlide >= totalSlides - slidesToShow) {
          nextBtn.disabled = true;
        } else {
          nextBtn.disabled = false;
        }
      }
    };

    // Add event listeners
    prevBtn.addEventListener('click', () => {
      if (this.thumbnails.slick) {
        this.thumbnails.slick.slickPrev();
        updateButtonStates();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (this.thumbnails.slick) {
        this.thumbnails.slick.slickNext();
        updateButtonStates();
      }
    });

    // Update button states when slider changes
    $(this.thumbnails).on('afterChange', () => {
      updateButtonStates();
    });

    // Update button states when slider is initialized
    $(this.thumbnails).on('init', () => {
      setTimeout(() => {
        updateButtonStates();
      }, 100);
    });

    // Handle window resize to update slider settings
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleResize();
        updateButtonStates();
      }, 250); // Debounce resize events
    });

    // Initial button state update
    setTimeout(() => {
      updateButtonStates();
    }, 100);
  }
}

customElements.define('slick-slider-component', SlickSliderComponent);



if(location.search.indexOf('mini-cart=open') >= 0) {
  document.getElementById('cart-icon-bubble').click()
}

class SwiperCoverflow extends HTMLElement {
  constructor() {
    super();

    this.parentSection = this.closest('.shopify-section');
    this.main = this.querySelector('.main__swiper');
    this.nav = this.querySelector('.nav__swiper');
  }

  initMain() {
    this.mainSwiper = new Swiper( this.main, {
      effect: "coverflow",
      grabCursor: false,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      initialSlide: this.dataset.initialSlide,
      coverflowEffect: {
        rotate: 0,
        stretch: 20,
        depth: 300,
        modifier: 1,
        slideShadows: false,
      }
    });
  }

  initNav() {
    const nextArrow = `.nav-${this.dataset.id} .swiper-button-next`;
    const prevArrow = `.nav-${this.dataset.id} .swiper-button-prev`;
    const _that = this;

    this.navSwiper = new Swiper( this.nav, {
      init: false,
      effect: "fade",
      slidesPerView: 1,
      initialSlide: this.dataset.initialSlide,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      }
    });

    this.navSwiper.on('init slideChangeTransitionEnd', function () {
      const currentSlide = _that.nav.querySelector('.swiper-slide-active');
      //_that.parentSection.querySelector('.section__reviews-holder').innerHTML = currentSlide.querySelector('.slide__product-reviews').innerHTML;
    });

    this.navSwiper.init();
  }

  connectedCallback() {
    this.initNav();
    this.initMain();

    this.mainSwiper.controller.control = this.navSwiper;
    this.navSwiper.controller.control = this.mainSwiper;
  }
}

customElements.define('swiper-coverflow', SwiperCoverflow);

class CarouselScrollbar extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector('.swiper');
  }

  init() {
    this.swiper = new Swiper(this.selector, {
      slidesPerView: "auto",
      spaceBetween: 20,
      watchSlidesProgress: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true
      },
      breakpoints: {
        767: {
          spaceBetween: 30
        }
      }
    });
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define('carousel-scrollbar', CarouselScrollbar);

class ReviewsSwiper extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector('.swiper');
    this.init();
  }

  init() {
    const nextArrow = `.nav-${this.dataset.sectionId}.swiper-button-next`;
    const prevArrow = `.nav-${this.dataset.sectionId}.swiper-button-prev`;

    this.swiper = new Swiper(this.selector, {
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      }
    });
  }
}

customElements.define('reviews-swiper', ReviewsSwiper);


$(document).ready(function(){

  $('.team-link-main').click(function(e){
    e.preventDefault();
    $(this).addClass('active-link');
    $(this).siblings().removeClass('active-link');

    var expanded = $(this).attr('aria-expanded','true');
    var expandedd = $(this).attr('aria-expanded');
    $(this).siblings().attr('aria-expanded','false');
    var mainLink = $(this).attr('data-match');

    $(this).parents('.dropdown_category_links').siblings('.sub_list-item').find('.'+mainLink).attr('aria-expanded','true');

    $(this).parents('.dropdown_category_links').siblings('.sub_list-item').find('.'+mainLink).siblings().attr('aria-expanded','false');
    $(this).parents('.dropdown_category_links').siblings('.teams-sub-links').css('transform','translate(0%)');
  });

  /* Minicart overlay close click */
  $('.sidecart-overlay').click(function(e) {
    $('.Drawer__Close').click();
    //lock mobile body
    mobileBodyLock('unlock');
  });

  /* Slick init minicart upsell */
  if($('#drawer-slide').length > 0){
    $('#drawer-slide').slick({
      arrows: true,
      slidesToShow: 4,
      infinite: false,
      centerMode: false,
      slidesToScroll: 1,
      centerMode: false,
      responsive: [
        {
          breakpoint: 751,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

});


/* Custom Event for Cart Item Remove to remove VU Customizer items */
document.addEventListener('cart:item:removed', function(event) {
  console.log(`%c cart:item:removed`, "color:green;font-size:30px;");
  // Fetch the current cart to review items
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(cart => {
    // Find items with "_ParentKey" property
    const upsellItems = cart.items.filter(item =>
      item.properties && item.properties._ParentKey
    );

    // Check each upsell item
    upsellItems.forEach(upsellItem => {
      const upsellKey = upsellItem.properties._ParentKey;

      // Search for matching recipe items with "_AssociationKey" property
      const matchingRecipeItem = cart.items.find(item =>
        item.properties &&
        item.properties._AssociationKey === upsellKey &&
        item.key !== upsellItem.key // Don't match with itself
      );

      // If no matching recipe item found, remove the upsell item
      if (!matchingRecipeItem) {
        console.log(`Removing orphaned upsell item with recipe ID: ${upsellKey}`);

        // Remove the orphaned upsell item
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: upsellItem.key,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(updatedCart => {
          // Refresh the cart display if needed
          if (typeof refreshCart === 'function') {
            refreshCart();
          }
          console.log('Orphaned upsell item removed successfully');
        })
        .catch(error => {
          console.error('Error removing orphaned upsell item:', error);
        });
      }
    });
  })
  .catch(error => {
    console.error('Error fetching cart for recipe cleanup:', error);
  });
});

// Hide variant-radios swatches if selected size has no matching li[data-size] items
function updateSelectedPrintName($container) {
  if (!$container || !$container.length) {
    $container = $('.style-swatch-container');
  }
  if (!$container.length) return;

  var $printNameEl = $container.find('.collection-metafield-swatches-selected-print');
  if (!$printNameEl.length) return;

  var $activeLink = $container.find('.collection-metafield-swatch-link.is-active').first();
  var printName = '';

  if ($activeLink.length) {
    printName = ($activeLink.attr('data-print-name') || '').trim();
    if (!printName) {
      var title = ($activeLink.attr('title') || '').trim();
      if (title.indexOf('-') !== -1) {
        printName = title.split('-').slice(1).join('-').trim();
      } else {
        printName = title;
      }
    }
  }

  $printNameEl.text(printName ? ' ' + printName : '');
}

function toggleVariantRadiosSwatchesVisibility() {
  var $container = $('.style-swatch-container');
  if (!$container.length) return;

  var selectedSize = $container.find('input[name="style-size-filter"]:checked').val();
  var $variantRadios = $('variant-radios.collection-metafield-swatches');
  if (!$variantRadios.length) return;

  if (!selectedSize) {
    $variantRadios.show();
    return;
  }

  var hasMatching = $variantRadios.find('ul li[data-size="' + selectedSize + '"]').length > 0;
  if (hasMatching) {
    $variantRadios.show();
  } else {
    $variantRadios.hide();
  }
}

// Sync style-size-radio and swatches to match current product (for back/forward navigation)
// Set window._syncStyleSwatchInProgress = true to prevent change handler from redirecting
function syncStyleSwatchToCurrentProduct() {
  var $container = $('.style-swatch-container');
  if (!$container.length) return;

  var currentSize = $container.data('current-product-size');
  var currentUrl = $container.data('current-product-url');
  if (!currentSize) return;

  var currentPath = (currentUrl || window.location.pathname).split('?')[0].replace(/\/$/, '') || '/';

  window._syncStyleSwatchInProgress = true;

  try {
    // Sync style-size-radio: check the one matching current product size
    $container.find('.style-size-radio').removeClass('is-active');
    var $matchingRadio = $container.find('input[name="style-size-filter"][value="' + currentSize + '"]');
    if ($matchingRadio.length) {
      $matchingRadio.prop('checked', true);
      $matchingRadio.closest('.style-size-radio').addClass('is-active');
    }

    // Sync swatch links: is-active on the one matching current page URL
    $container.find('.collection-metafield-swatch-link').removeClass('is-active');
    $container.find('.collection-metafield-swatch-link').each(function() {
      var href = $(this).attr('href') || '';
      var linkPath = (href.split('?')[0] || '').replace(/\/$/, '') || '/';
      if (linkPath && linkPath === currentPath) {
        $(this).addClass('is-active');
      }
    });

    // Re-filter swatches and re-run init
    initSwatchesSlick();
    toggleVariantRadiosSwatchesVisibility();
    updateSelectedPrintName($container);
  } finally {
    window._syncStyleSwatchInProgress = false;
  }
}

// Run sync multiple times over 6 seconds to keep variant correct after load/back/forward
function syncStyleSwatchWithRetry() {
  syncStyleSwatchToCurrentProduct();
  [500, 1000, 2000, 4000, 6000].forEach(function(ms) {
    setTimeout(syncStyleSwatchToCurrentProduct, ms);
  });
}

// Collection Metafield Swatches with Load More Link (New Design)
// Collection Metafield Swatches with Load More Link (New Design)
function initSwatchesSlick() {
  var swatchesSlider = $('.js-collection-metafield-swatches-slider');
  
  if (swatchesSlider.length > 0) {
    // Get wrapper for Load More link placement
    var $container = swatchesSlider.closest('.style-swatch-container');
    var $loadMoreLink = $container.find('.collection-metafield-swatches-load-more');
    
    // Remove old expand button if it exists
    swatchesSlider.closest('.collection-metafield-swatches-slider-wrapper').find('.collection-metafield-swatches-expand-btn').remove();
    
    // Remove arrow buttons completely - no slider needed
    swatchesSlider.closest('.collection-metafield-swatches-slider-wrapper').find('.collection-metafield-swatches-arrow-prev, .collection-metafield-swatches-arrow-next').remove();
    
    // Get active filter from radio button
    var activeFilter = $container.find('input[name="style-size-filter"]:checked').val();
    
    // Create unique key for this filter state
    var stateKey = activeFilter || 'default';
    
    // Check if this filter was previously expanded
    var isExpanded = swatchesExpandedState[stateKey] === true;
    
    // Get all items
    var $items = swatchesSlider.find('li');
    // Show 8 items (1 row) on mobile, 16 items (2 rows) on desktop
    var isMobile = window.innerWidth <= 990;
    var itemsToShow = isMobile ? 8 : 16;
    
    // Filter by active filter if exists
    if (activeFilter) {
      $items.each(function() {
        var $item = $(this);
        var itemSize = $item.data('size');
        if (itemSize !== activeFilter) {
          $item.hide();
        } else {
          $item.show();
        }
      });
    }
    
    // Count visible items and apply limit ONLY if not expanded
    if (!isExpanded) {
      var visibleItems = swatchesSlider.find('li:visible');
      var visibleCount = 0;
      visibleItems.each(function() {
        visibleCount++;
        if (visibleCount > itemsToShow) {
          $(this).addClass('swatch-item-hidden').hide();
        } else {
          $(this).removeClass('swatch-item-hidden').show();
        }
      });
    } else {
      // If expanded, show all matching items
      swatchesSlider.find('li:visible').removeClass('swatch-item-hidden').show();
    }
    
    // Recalculate hidden count
    var totalMatchingItems = 0;
    $items.each(function() {
      var $item = $(this);
      var itemSize = $item.data('size');
      if (!activeFilter || itemSize === activeFilter) {
        totalMatchingItems++;
      }
    });
    var hiddenCount = totalMatchingItems > itemsToShow ? totalMatchingItems - itemsToShow : 0;
    
    // Show/hide Load More link based on expanded state
    if (!isExpanded && hiddenCount > 0) {
      $loadMoreLink.removeClass('is-hidden').show().attr('data-expanded', 'false').text('Load More');
    } else {
      $loadMoreLink.addClass('is-hidden').hide();
    }
    
    // Do not mark as ready here; initial ready is controlled after limiting
    toggleVariantRadiosSwatchesVisibility();
  }
}

$(document).ready(function() {
  initSwatchesSlick();

  // Sync style swatch on back/forward navigation (with retries over 6 seconds)
  window.addEventListener('popstate', syncStyleSwatchWithRetry);
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) syncStyleSwatchWithRetry();
  });
  
  // Sync on initial load (product page) - run after 300ms and retry over 6 seconds
  setTimeout(function() {
    if ($('.style-swatch-container').length) syncStyleSwatchWithRetry();
  }, 300);
  
  // Auto-apply first filter on initial load
  setTimeout(function() {
    var firstActiveRadio = document.querySelector('input[name="style-size-filter"]:checked');
    if (firstActiveRadio) {
      var filter = firstActiveRadio.value;
      var slider = jQuery('.js-collection-metafield-swatches-slider');
      var $container = slider.closest('.style-swatch-container');
      
      if (slider.length > 0) {
        // Hide/show <li> based on first active filter
        slider.find('li').each(function() {
          const itemSize = jQuery(this).data('size');
          if (itemSize === filter) {
            jQuery(this).show();
          } else {
            jQuery(this).hide();
          }
        });
        
        // Update Load More link and limit immediately (no delay)
        var isMobile = window.innerWidth <= 990;
        var itemsToShow = isMobile ? 5 : 10;
        
        // Apply limit to visible items
        var visibleCount = 0;
        slider.find('li:visible').each(function() {
          visibleCount++;
          if (visibleCount > itemsToShow) {
            jQuery(this).addClass('swatch-item-hidden').hide();
          } else {
            jQuery(this).removeClass('swatch-item-hidden').show();
          }
        });
        
        // Calculate total matching items
        var totalMatchingItems = 0;
        slider.find('li').each(function() {
          var itemSize = jQuery(this).data('size');
          if (!filter || itemSize === filter) {
            totalMatchingItems++;
          }
        });
        var hiddenCount = totalMatchingItems > itemsToShow ? totalMatchingItems - itemsToShow : 0;
        
        // Update Load More link (ensure closed state)
        var $loadMoreLink = $container.find('.collection-metafield-swatches-load-more');
        if (hiddenCount > 0) {
          $loadMoreLink
            .removeClass('is-hidden')
            .show()
            .attr('data-expanded', 'false')
            .text('Load More');
        } else {
          $loadMoreLink.addClass('is-hidden').hide();
        }
        
        // Now safe to reveal swatches
        slider.closest('.collection-metafield-swatches').addClass('is-ready');
        toggleVariantRadiosSwatchesVisibility();
      }
    }
  }, 200);
  
  // Load More link click handler
  // Load More link click handler
  $(document).on('click', '.collection-metafield-swatches-load-more', function(e) {
    e.preventDefault();
    var $link = $(this);
    var $container = $link.closest('.style-swatch-container');
    var slider = $container.find('.js-collection-metafield-swatches-slider');
    var activeFilter = $container.find('input[name="style-size-filter"]:checked').val();
    
    // Create unique key for this filter state
    var stateKey = activeFilter || 'default';
    
    // Mark this filter as expanded
    swatchesExpandedState[stateKey] = true;
    
    // Show all hidden items that match the current filter
    slider.find('li.swatch-item-hidden').each(function() {
      var $item = jQuery(this);
      var itemSize = $item.data('size');
      if (!activeFilter || itemSize === activeFilter) {
        $item.removeClass('swatch-item-hidden');
        $item.slideDown(300);
      }
    });
    
    // Hide the Load More link after expanding
    $link.addClass('is-hidden').hide();
  });
});

  // Reinitialize when new swatches are added
  var swatchesObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var hasSwatches = node.classList && node.classList.contains('collection-metafield-swatches');
            var hasSwatchesChild = node.querySelector && node.querySelector('.collection-metafield-swatches');
            if (hasSwatches || hasSwatchesChild) {
              setTimeout(initSwatchesSlick, 100);
            }

          }
        });
      }
    });
  });

  swatchesObserver.observe(document.body, {
    childList: true,
    subtree: true
  });



 // New radio button filter handler for style swatches
// Flag to prevent automatic swatch clicks from re-enabling the button
window._preventSwatchClick = false;

$(document).on('change', 'input[name="style-size-filter"]', function() {
  // Skip redirect when syncing from back/forward - only redirect on user click
  if (window._syncStyleSwatchInProgress) return;

  var filter = $(this).val();
  var $container = $(this).closest('.style-swatch-container');
  var stateKey = filter || 'default';
  swatchesExpandedState[stateKey] = false;
  var slider = $container.find('.js-collection-metafield-swatches-slider');
  var $loadMoreLink = $container.find('.collection-metafield-swatches-load-more');
  
  // Disable add-to-cart button immediately on radio change
  var $addToCartBtn = $('a#add-to-cart-button');
  $addToCartBtn.prop('disabled', true).addClass('disabled');
  
  // Set flag to prevent automatic swatch click from triggering enable logic
  window._preventSwatchClick = true;
  
  // Hide swatches while recalculating to avoid partial render
  slider.closest('.collection-metafield-swatches').removeClass('is-ready');
  
  // Update radio button visual state
  $container.find('.style-size-radio').removeClass('is-active');
  $(this).closest('.style-size-radio').addClass('is-active');
  
  // Remove all is-active classes first
  slider.find('li a').removeClass('is-active');
  
  // Hide/show <li> based on selected filter
  var firstVisibleLink = null;
  slider.find('li').each(function() {
    var itemSize = $(this).data('size');
    if (itemSize === filter) {
      $(this).show().removeClass('swatch-item-hidden');
      // Store the first visible link
      if (!firstVisibleLink) {
        firstVisibleLink = $(this).find('a');
      }
    } else {
      $(this).hide();
    }
  });
  
  // Add is-active class to the first visible link
  if (firstVisibleLink) {
    firstVisibleLink.addClass('is-active');
        updateSelectedPrintName($container);

    // Trigger click on the first visible link to update the variant
    // Use a small delay to ensure DOM is updated
    setTimeout(function() {
      if (firstVisibleLink.length) {
        // Get the href and navigate to update the variant
        var href = firstVisibleLink.attr('href');
        if (href && href !== '#' && href !== 'javascript:void(0)') {
          window.location.href = href;
        }
      }
      
      // Reset the flag after navigation
      setTimeout(function() {
        window._preventSwatchClick = false;
      }, 500);
    }, 50);
  }

  // Update hidden items and Load More link after filtering
  setTimeout(function() {
    var isMobile = window.innerWidth <= 990;
    var itemsToShow = isMobile ? 8 : 16;
    
    // Apply limit to visible items
    var visibleCount = 0;
    slider.find('li:visible').each(function() {
      visibleCount++;
      if (visibleCount > itemsToShow) {
        $(this).addClass('swatch-item-hidden').hide();
      } else {
        $(this).removeClass('swatch-item-hidden').show();
      }
    });
    
    // Calculate total matching items
    var totalMatchingItems = 0;
    slider.find('li').each(function() {
      var itemSize = $(this).data('size');
      if (!filter || itemSize === filter) {
        totalMatchingItems++;
      }
    });
    var hiddenCount = totalMatchingItems > itemsToShow ? totalMatchingItems - itemsToShow : 0;
    
    // Update Load More link
    if (hiddenCount > 0) {
      $loadMoreLink.removeClass('is-hidden').show().attr('data-expanded', 'false').text('Load More');
    } else {
      $loadMoreLink.addClass('is-hidden').hide();
    }
    
    // Reveal swatches after fully recalculated
    slider.closest('.collection-metafield-swatches').addClass('is-ready');
    toggleVariantRadiosSwatchesVisibility();
  }, 100);
});

// Re-enable add-to-cart button 3 seconds after MANUAL click on any swatch item
$(document).on('click', '.js-collection-metafield-swatches-slider li', function(e) {
  // Ignore clicks triggered programmatically during radio change
  if (window._preventSwatchClick) {
    return;
  }
  
  var $link = $(this).find('a.collection-metafield-swatch-link');
  if ($link.length) {
    var $container = $(this).closest('.style-swatch-container');
    $container.find('.collection-metafield-swatch-link').removeClass('is-active');
    $link.addClass('is-active');
    updateSelectedPrintName($container);
  }
  
  var $addToCartBtn = $('a#add-to-cart-button');
  
  // Disable button immediately on click
  $addToCartBtn.prop('disabled', true).addClass('disabled');
  
  // Clear any existing timeout to prevent multiple timers
  if (window._addToCartEnableTimeout) {
    clearTimeout(window._addToCartEnableTimeout);
  }
  
  // Re-enable after 3 seconds
  window._addToCartEnableTimeout = setTimeout(function() {
    $addToCartBtn.prop('disabled', false).removeClass('disabled');
  }, 5000);
});